module.exports = __webpack_public_path__ + "img/promotion-sample.d2b073f4.jpg";